module.exports = __webpack_public_path__ + "static/media/ally_pro_web_10.4c656b49.jpg";